import { ListProductUnitsActions, ListProductUnitsRequestAction } from './../../ducks/productUnits/listProductUnits';
import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler, applyQueryString } from 'services';

export function* listProductUnitsRequest(action: any) {
  const { query = {}, onSuccess, onFailure }: ListProductUnitsRequestAction = action;
  try {
    const url = applyQueryString('product-units', {
      ...query,
      asList: 1,
      orderBy: 'name',
      direction: 'asc',
    });
    const { data } = yield call(api.get, url);
    onSuccess && onSuccess();
    yield put(ListProductUnitsActions.success(data));
  } catch (error) {
    const { errorMessage } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(ListProductUnitsActions.failure(errorMessage));
  }
}
